export default {"src":"/_next/static/media/PO-Finance.c23f705b.svg","height":30,"width":22};